import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import Vuelidate from 'vuelidate';
import vuexI18n from 'vuex-i18n';
import firebase from 'firebase';

import App from './App.vue';
import { routes } from './routes';
import { translationsEn } from './langs/en';
import { translationsZhTw } from './langs/zh-TW';

Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(VueResource);

//Vuex-i18n
const store = new Vuex.Store();
Vue.use(vuexI18n.plugin, store, {
	moduleName: 'i18n',
	onTranslationNotFound (locale, key) {
    console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`);
    console.log(`'${key}':'${key}',`);
  }}
);

Vue.i18n.add('en', translationsEn);
Vue.i18n.add('zh-TW', translationsZhTw);

// Vue.http.options.root = process.env.VUE_APP_FIREBASE_DATABASEURL;

// Vue.filter('currency', (value) => {
//   return '$' + value.toLocaleString();
// });

const router = new VueRouter({
  mode: 'history',
  routes
});

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
};
firebase.initializeApp(config);


new Vue({
  name: 'TicketShooter',
  el: '#app',
  router,
  store,
  render: h => h(App)
})
